import React, { useState, useRef, useEffect } from "react";
import CloseButton from "../assets/dashNeedHelpClose.svg";
import MailImg from "../assets/dashboardmailimg.svg";
import { Tab, Tabs } from "@mui/material";
import faqIcon from "../assets/faqIconBgWhite.png";
import AccordionComponent from "../../dashboard/components/AccordionComponent";
import strings from "../../../utils/Strings";
import registerItem from "../../../assets/images/LiveSession/registerItem.svg";
import item from "../../../assets/images/LiveSession/item.svg";
import "../styles/LiveSessionTab.css";
import ScrollUpButton from "../assets/needhelp/scrollup.svg";
import ScrollDownButton from "../assets/needhelp/scrolldown.svg";
export interface RightModalProps {
  isOpen?: boolean;
  toggleModal?: () => void;
}

export const ContentWrapper = ({
  question,
  children,
  onClose,
}: {
  question: string;
  children: React.ReactNode;
  onClose: () => void;
}) => (
  <div
    style={{
      margin: "20px",
      // border: "1px solid #ddd",
      borderRadius: "40px",
    }}
  >
    {/* Header with Question + Close button */}
    <div
      style={{
        // backgroundColor: "#c3f1ff",
        backgroundColor: "#FFFFFF",
        padding: "20px",

        borderTopLeftRadius: "40px",
        borderTopRightRadius: "40px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        cursor: "pointer",
      }}
      onClick={onClose}
    >
      <span
        style={{
          fontSize: "16px",
          fontWeight: 400,
          fontFamily: "Mazzard",
          color: "#242730",
        }}
      >
        {question}
      </span>
      <span style={{ fontWeight: "bold", fontSize: "20px" }}>
        <img src={""} />
      </span>
    </div>

    {/* Content */}
    <div
      style={{
        padding: "20px",
        paddingTop: "0px",
        // backgroundColor: "#c3f1ff",
        backgroundColor: "#FFFFFF",
        borderBottomLeftRadius: "40px",
        borderBottomRightRadius: "40px",
      }}
    >
      {children}
    </div>
  </div>
);

export const QuestionHeader = ({
  text,
  onClick,
}: {
  text: string;
  onClick: () => void;
}) => (
  <h1
    style={{
      fontSize: "16px",
      backgroundColor: "#FFFFFF",
      margin: "20px",
      padding: "15px",
      paddingRight: "20px",
      paddingLeft: "20px",
      borderRadius: "40px",
      cursor: "pointer",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontWeight: 400,
      color: "#242730",
      fontFamily: "Mazzard",
    }}
    onClick={onClick}
  >
    {text}
    <span style={{ fontWeight: "bold", fontSize: "20px" }}>
      <img src={""} />
    </span>
  </h1>
);

const LiveSessionNeedHelp: React.FC<RightModalProps> = ({
  isOpen,
  toggleModal,
}) => {
  const contentRef = useRef<HTMLDivElement>(null);
  const [isScrolledToTop, setIsScrolledToTop] = useState(true);
  const [isScrolledToBottom, setIsScrolledToBottom] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      if (contentRef.current) {
        const { scrollTop, scrollHeight, clientHeight } = contentRef.current;
        const tolerance = 10; // Larger tolerance to handle edge cases

        setIsScrolledToTop(scrollTop <= tolerance);
        setIsScrolledToBottom(
          scrollTop + clientHeight >= scrollHeight - tolerance,
        );
      }
    };
    const refCurrent = contentRef.current;
    if (refCurrent) {
      refCurrent.addEventListener("scroll", handleScroll);
    }

    handleScroll();

    return () => {
      if (refCurrent) {
        refCurrent.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isOpen]);

  const handleScrollDown = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: 100, behavior: "smooth" });
    }
  };

  const handleScrollUp = () => {
    if (contentRef.current) {
      contentRef.current.scrollBy({ top: -1000, behavior: "smooth" });
    }
  };

  const onTabChange = (index: number) => {
    setActiveTab(index);
  };
  return (
    <>
      {isOpen && (
        <div className="dashboardv2-needhelp-overlay" onClick={toggleModal} />
      )}
      <div
        className={`dashboardv2-needhelp-right-modal ${isOpen ? "open" : ""}`}
      >
        {/* Dashboard Need Help Header */}
        <div className="dashboardv2-needhelp-header">
          <div className="dashboardv2-needhelp-headerrow">
            <img src={faqIcon} alt="contact-button" />
            <h4>Need help?</h4>
          </div>
          <div className="dashboardv2-needhelp-header-end">
            <div className="dashboardv2-needhelp-contact-header">
              <img
                src={MailImg}
                className="dashboardv2-needhelp-contact-image"
                alt="contact-button"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              />
              <div
                className="dashboardv2-needhelp-contact-text"
                onClick={() => {
                  window.open(
                    "https://mail.google.com/mail/?view=cm&fs=1&to=support@jozuna.com",
                    "_blank",
                  );
                }}
              >
                Get Support
              </div>
            </div>
            <img
              src={CloseButton}
              className="dashboardv2-close"
              onClick={toggleModal}
              alt="close-button"
            />
          </div>
        </div>
        {/* Dashboard Need Help Body Top */}

        {/* Divider */}
        <div
          className="curriculum-needhelp-horizontal-divider"
          style={{
            marginLeft: "15px",
            marginRight: "15px",
            marginBottom: "15px",
          }}
        ></div>

        {
          <div className="v2-livesession-needhelp-container" ref={contentRef}>
            <div className="v2-livesession-needhelp-sub-container">
              <AccordionComponent title="Will I be notified of a Live Session?">
                <div
                  style={{
                    fontFamily: "Mazzard",
                    fontSize: "14px",
                  }}
                >
                  You will receive notifications via email and on your Jozuna
                  mobile application when live sessions with experts are
                  configured. You will also see the scheduled live session
                  appear in your Learning schedule calendar.
                </div>
              </AccordionComponent>

              <AccordionComponent title="Should I register for a Live Session?">
                <div
                  style={{
                    fontFamily: "Mazzard",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "space-between",
                  }}
                >
                  Registering for the live session keeps you updated about
                  changes in schedule or other details.
                  <img
                    src={registerItem}
                    alt=""
                    style={{
                      height: "20%",
                      width: "20%",
                    }}
                  />
                </div>
              </AccordionComponent>

              <AccordionComponent title="How do I see the meeting link and other details?">
                <div
                  style={{
                    fontFamily: "Mazzard",
                    fontSize: "14px",
                    display: "flex",
                    alignItems: "start",
                    justifyContent: "space-between",
                  }}
                >
                  The meeting link and associated details appear when you
                  register.
                  <img
                    src={item}
                    alt=""
                    style={{
                      height: "20%",
                      width: "20%",
                    }}
                  />
                </div>
              </AccordionComponent>
            </div>

            {/* Scroll Buttons */}
            {/* {isOpen && (
              <div className="v2-livesession-scroll-buttons">
                <img
                  height={"60px"}
                  width={"120px"}
                  src={isScrolledToBottom ? ScrollUpButton : ScrollDownButton}
                  alt={isScrolledToBottom ? "Scroll Up" : "Scroll Down"}
                  className="v2-livesession-scroll-btn"
                  onClick={
                    isScrolledToBottom ? handleScrollUp : handleScrollDown
                  }
                  style={{ cursor: "pointer" }}
                />
              </div>
            )} */}
          </div>
        }
      </div>
    </>
  );
};

export default LiveSessionNeedHelp;
